import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'duration',
    standalone: false
})
export class DurationPipe implements PipeTransform {

  transform(value: string): string {
    let milliseconds: number = Math.round(moment.duration(value).asMilliseconds());
    let seconds: number = Math.round(moment.duration(value).asSeconds());
    let minutes: number = Math.round(moment.duration(value).asMinutes());
    let hours: number = Math.round(moment.duration(value).asHours());
    let days: number = Math.round(moment.duration(value).asDays());
    if(milliseconds < 1000){
      return $localize`Less than a second`;
    } else if (seconds < 60) {
      return $localize`Less than a minute`;
    } else if (minutes < 60) {
      return (minutes == 1) ? $localize`${minutes} minute` : $localize`${minutes} minutes`;
    } else if (hours < 24) {
      return (hours == 1) ? $localize`${hours} hour` : $localize`${hours} hours`;
    } else {
      return (days == 1) ? $localize`${days} day` : $localize`${days} days`;
    }

  }

}
